import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/all";

import "./withdraw_styles/withdraw_sec2.css";

export default function Withdraw_sec2() {

  const [closeVerify, setCloseVerify] = useState(true);

  const handleCloseVerify = () => {
    setCloseVerify(false);
  }

  return (
    <>
      <Container className="mt-5">
        {closeVerify && 
        (
          <Row className="mt-3">
            <Col>
          <div className="after_verif d-flex justify-content-between">
            {/* Cards */}
            <div className="4_boxes">
              <div className="d-flex gap-4 wd_bx_4">
                {/* First box */}
                <div className="wd_fst_box">
                  <div className="cnt_bg">
                    <span>1</span>
                  </div>
                  <div>
                    <h6>Initiate a Withdrawl</h6>
                    <p>Start a withdrawl request on Binance.</p>
                  </div>
                </div>
                {/* Second box */}
                <div className="wd_scnd_box">
                  <div className="cnt_bg">
                    <span>2</span>
                  </div>
                  <div>
                    <h6>Get Withdrawl Address</h6>
                    <p>Copy and paste the deposit address of the receiver.</p>
                  </div>
                </div>
                {/* Third box */}
                <div className="wd_scnd_box">
                  <div className="cnt_bg">
                    <span>3</span>
                  </div>
                  <div>
                    <h6>Network Confirmation</h6>
                    <p>Wait for withdrawl network confirmation.</p>
                  </div>
                </div>
                {/* Fourth box */}
                <div className="wd_scnd_box">
                  <div className="cnt_bg">
                    <span>4</span>
                  </div>
                  <div>
                    <h6>Withdrawl Successful</h6>
                    <p>Deposit successflly sent to receiver's address.</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Close Button */}
            <div className="closebtn" onClick={handleCloseVerify} style={{cursor:'pointer'}}>
              <i>
                <AiOutlineClose />
              </i>
            </div>
          </div>
          </Col>
        </Row>
        )
        }
      </Container>
    </>
  );
}
